export enum StatoLavorazione
{
    IN_ATTESA_DI_ACCETTAZIONE_DI_FORNITORE = "IN_ATTESA_DI_ACCETTAZIONE_DI_FORNITORE",
    IN_ATTESA_DI_ACCETTAZIONE_DI_BC = "IN_ATTESA_DI_ACCETTAZIONE_DI_BC",
    ACCETTATO_IN_ATTESA_DI_CONSEGNA_A_FORNITORE = "ACCETTATO_IN_ATTESA_DI_CONSEGNA_A_FORNITORE",
    CONSEGNATO_A_FORNITORE = "CONSEGNATO_A_FORNITORE",
    CONSEGNA_A_FORNITORE_PROCESSATA = "CONSEGNA_A_FORNITORE_PROCESSATA",
    IN_CORSO_DI_LAVORAZIONE = "IN_CORSO_DI_LAVORAZIONE",
    COMPLETATO_IN_ATTESA_DI_RIENTRO = "COMPLETATO_IN_ATTESA_DI_RIENTRO",
    RIENTRATO = "RIENTRATO",
    RIENTRO_PROCESSATO = "RIENTRO_PROCESSATO"
}